/**
 * @generated SignedSource<<b360007a41c46112f857e2014df99d44>>
 * @relayHash 3a1f077ad23bff1c8e7745b5c439493d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 8b88b3ea716c8636c0fbc588064080bab603a128b7d32f46a76592d8e8692d29

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type L1MenuItemsQuery$variables = {
  cloudId: string;
  isPlansExpanded?: boolean | null | undefined;
  isProjectsExpanded?: boolean | null | undefined;
};
export type L1MenuItemsQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ConfigurableMenu">;
};
export type L1MenuItemsQuery = {
  response: L1MenuItemsQuery$data;
  variables: L1MenuItemsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "isPlansExpanded"
},
v2 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "isProjectsExpanded"
},
v3 = {
  "kind": "ScalarField",
  "name": "id"
},
v4 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v5 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v6 = {
  "kind": "InlineFragment",
  "selections": [
    (v3/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
},
v7 = [
  {
    "kind": "LinkedField",
    "name": "node",
    "plural": false,
    "selections": [
      (v5/*: any*/),
      {
        "kind": "InlineFragment",
        "selections": [
          (v3/*: any*/),
          {
            "alias": "projectKey",
            "kind": "ScalarField",
            "name": "key"
          },
          {
            "concreteType": "JiraAvatar",
            "kind": "LinkedField",
            "name": "avatar",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "small"
              }
            ]
          },
          {
            "kind": "ScalarField",
            "name": "name"
          },
          {
            "kind": "ScalarField",
            "name": "projectType"
          },
          {
            "kind": "LinkedField",
            "name": "navigationMetadata",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "boardId"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "isSimpleBoard"
                  },
                  (v3/*: any*/)
                ],
                "type": "JiraSoftwareProjectNavigationMetadata"
              }
            ]
          },
          {
            "kind": "ScalarField",
            "name": "isFavourite"
          },
          {
            "kind": "ScalarField",
            "name": "projectUrl"
          },
          {
            "args": [
              {
                "kind": "Literal",
                "name": "type",
                "value": "EDIT_PROJECT_CONFIG"
              }
            ],
            "concreteType": "JiraProjectAction",
            "kind": "LinkedField",
            "name": "action",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "canPerform"
              }
            ],
            "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
          }
        ],
        "type": "JiraProject"
      },
      (v6/*: any*/)
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "L1MenuItemsQuery",
    "selections": [
      {
        "kind": "FragmentSpread",
        "name": "ConfigurableMenu"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "L1MenuItemsQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "cloudID",
                "variableName": "cloudId"
              },
              {
                "kind": "Literal",
                "name": "navKey",
                "value": "NAV_SIDEBAR"
              }
            ],
            "concreteType": "JiraUserNavigationConfiguration",
            "kind": "LinkedField",
            "name": "userNavigationConfiguration",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraConfigurableNavigationItem",
                "kind": "LinkedField",
                "name": "navItems",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "menuId"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "isVisible"
                  }
                ]
              },
              (v3/*: any*/)
            ]
          }
        ]
      },
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "condition": "isProjectsExpanded",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": [
                  (v4/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "filter",
                    "value": {
                      "type": "PROJECT"
                    }
                  },
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 15
                  }
                ],
                "concreteType": "JiraFavouriteConnection",
                "kind": "LinkedField",
                "name": "favourites",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "hasNextPage"
                      }
                    ]
                  },
                  {
                    "concreteType": "JiraFavouriteEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": (v7/*: any*/)
                  }
                ]
              },
              {
                "args": [
                  (v4/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 20
                  },
                  {
                    "kind": "Literal",
                    "name": "types",
                    "value": [
                      "PROJECT"
                    ]
                  }
                ],
                "concreteType": "JiraSearchableEntityConnection",
                "kind": "LinkedField",
                "name": "recentItems",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraSearchableEntityEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": (v7/*: any*/)
                  }
                ]
              }
            ]
          },
          {
            "alias": "canCreateProject",
            "args": [
              (v4/*: any*/),
              {
                "kind": "Literal",
                "name": "type",
                "value": "CREATE_PROJECT"
              }
            ],
            "kind": "ScalarField",
            "name": "canPerform"
          }
        ]
      },
      {
        "condition": "isPlansExpanded",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
              {
                "alias": "planFavourites",
                "args": [
                  (v4/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "filter",
                    "value": {
                      "type": "PLAN"
                    }
                  },
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 10
                  }
                ],
                "concreteType": "JiraFavouriteConnection",
                "kind": "LinkedField",
                "name": "favourites",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraFavouriteEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v3/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "planId"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "title"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "planUrl"
                              }
                            ],
                            "type": "JiraPlan"
                          },
                          (v6/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "8b88b3ea716c8636c0fbc588064080bab603a128b7d32f46a76592d8e8692d29",
    "metadata": {},
    "name": "L1MenuItemsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "2975ea7b695e070f2bf4bb32ca9d336e";

export default node;
